import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { OktaAuth } from '@okta/okta-auth-js';
import Loader from '@/components/atoms/Loader';

const oktaAuth = new OktaAuth({
  issuer: import.meta.env.VITE_APP_OKTA_ISSUER,
  clientId: import.meta.env.VITE_APP_OKTA_CLIENT_ID,
  redirectUri: import.meta.env.VITE_APP_OKTA_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
});

const LoginCallback = () => {
  const navigate = useNavigate();
  useEffect(() => {
    void oktaAuth
      .handleLoginRedirect()
      .then(() => navigate('/invoices'))
      .catch((err: unknown) => {
        console.log(err);
        if (err instanceof Error) {
          console.error('Redirect Error:', err.message);
        } else {
          console.error('Redirect Error:', err);
        }
      });
  }, [navigate]);

  return (
    <div>
      <Loader display={true} />
    </div>
  );
};

export default LoginCallback;
